export default __webpack_public_path__ + "static/media/best-skill-home-msg.fe1c67a6.svg";